import React, { useState } from 'react';
const faqs = [{
  question: '¿A qué edad puedo empezar a aplicar el protocolo?',
  answer: 'Desde el día 1 de vida. Los pilares de Sueño y Estimulación son aplicables desde la primera semana. El protocolo está diseñado para acompañar todo el primer año con ajustes específicos para cada etapa.'
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'Muchos padres reportan mejoras en el sueño en menos de 72 horas al implementar las Ventanas de Vigilia y la Rutina de 4 Elementos. Los resultados completos del protocolo se consolidan en 2-4 semanas.'
}, {
  question: '¿Es compatible con la lactancia materna?',
  answer: '100%. El protocolo es completamente agnóstico al tipo de alimentación. La lactancia materna es el vehículo ideal para el DHA y los anticuerpos, y el protocolo está diseñado para potenciarla, no reemplazarla.'
}, {
  question: '¿Funciona si tengo gemelos?',
  answer: 'Sí. La clave con gemelos es sincronizar sus rutinas desde el principio. El protocolo de Ventanas de Vigilia es especialmente crítico para mantener a dos bebés sincronizados y es perfectamente aplicable.'
}, {
  question: '¿Cómo recibo los materiales?',
  answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con los enlaces de descarga del ebook principal y los 4 bonos en formato PDF. El acceso es instantáneo, 24/7.'
}, {
  question: '¿Necesito comprar materiales especiales?',
  answer: 'No. El 90% del protocolo utiliza lo que ya tienes en casa. El cerebro de tu bebé y tu voz son las herramientas más poderosas. El Bono 4 "Ahorra $2000 en su Primer Año" te muestra exactamente lo que NO necesitas comprar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-124">
      <div className="max-w-[900px] mx-auto" data-id="element-125">
        <div className="text-center mb-2.5" data-id="element-126">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-127">
            Respondemos tus preguntas
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-12 leading-tight text-center" data-id="element-128">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-[750px] mx-auto space-y-3" role="list" data-id="element-129">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          const answerId = `faq-answer-${idx}`;
          const questionId = `faq-question-${idx}`;
          return <div key={idx} role="listitem" className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-130">
                <h3 className="m-0" data-id="element-131">
                  <button id={questionId} onClick={() => toggleFAQ(idx)} aria-expanded={isOpen} aria-controls={answerId} className="w-full bg-transparent p-5 flex justify-between items-center text-base text-[#3D2B1F] font-semibold text-left transition-colors hover:bg-[#FAF7F2] border-none cursor-pointer" data-id="element-132">
                    <span className="pr-4" data-id="element-133">{faq.question}</span>
                    <span aria-hidden="true" className={`text-2xl text-[#B76E79] flex-shrink-0 transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-134">
                      +
                    </span>
                  </button>
                </h3>
                <div id={answerId} role="region" aria-labelledby={questionId} hidden={!isOpen} className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-135">
                  <p className="px-6 text-base text-[#6B4C3B] font-sans leading-relaxed" data-id="element-136">
                    {faq.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}